module.exports = __webpack_public_path__ + "static/hero-vp8.fef30f36.webm";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/hero-vp8.webm
// module id = 3712
// module chunks = 35783957827783